import React from 'react';
import { GetColor } from '../../../../utils';
import * as s from './styled-pracas-mapa';

// Legenda de status dos markers no canto inferior esquerdo do mapa.
// Agora interativa: cada item e botao que toggla o filtro do status
// correspondente. Visual feedback: ativo = solid + dot cheio; inativo
// = opacity reduzida + dot outline.
//
// activeFilters: array de status atualmente filtrados (mostrados)
// onToggle(statusName): callback do click
// counts: { [statusName]: nº de maquinas } — contagem ao lado de cada item
//   (resumo de relance). Opcional; sem ele, so a label.
const LEGEND_ITEMS = [
  { name: 'alarme/bloqueio', label: 'Alarme/Bloqueio' },
  { name: 'atenção', label: 'Atenção' },
  { name: 'rodando', label: 'Rodando' },
  { name: 'desligada', label: 'Desligada' },
  { name: 'sem dados', label: 'Sem dados' },
];

const MapLegend = ({ activeFilters, onToggle, counts }) => (
  <s.MapLegend>
    {LEGEND_ITEMS.map(({ name, label }) => {
      const count = counts ? counts[name] : null;
      // Default: tudo ativo se nao passou activeFilters/onToggle (modo
      // backward-compatible). Quando passa, vira interativo.
      const interactive = !!onToggle;
      const isActive = interactive
        ? (activeFilters || []).includes(name)
        : true;
      return (
        <s.MapLegendItem
          key={name}
          as={interactive ? 'button' : 'div'}
          type={interactive ? 'button' : undefined}
          $interactive={interactive}
          $active={isActive}
          onClick={interactive ? () => onToggle(name) : undefined}
          title={
            interactive
              ? isActive
                ? `Esconder parques em ${label}`
                : `Mostrar parques em ${label}`
              : undefined
          }
        >
          <s.MapLegendDot color={GetColor(name)} $hollow={!isActive} />
          {label}
          {count != null && <s.MapLegendCount>{count}</s.MapLegendCount>}
        </s.MapLegendItem>
      );
    })}
  </s.MapLegend>
);

export default MapLegend;
